exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:1200px){.divider[data-v-f65b5e60]{border-left:1px solid #ccd9e2}.group-1[data-v-f65b5e60]{max-width:190px!important}.group-2[data-v-f65b5e60]{max-width:170px!important}.group-3[data-v-f65b5e60],.group-4[data-v-f65b5e60]{max-width:650px!important}}@media screen and (min-width:1200px) and (max-width:1399px){.group-3 .divider[data-v-f65b5e60]{padding-right:1rem!important}.group-3 .divider[data-v-f65b5e60],.group-4 .divider[data-v-f65b5e60]{padding-left:1rem!important}.group-3 .medium .value[data-v-f65b5e60]{font-size:20px}}", ""]);

// exports
